export const SOCIAL_NETWORKS = {
  linkedIn: {
    name: 'linkedin',
    title: 'LinkedIn',
    profileURL: 'https://linkedin.com/in/jmtov/',
  },
  github: {
    name: 'github',
    title: 'GitHub',
    profileURL: 'https://github.com/jmtov/',
  },
  codepen: {
    name: 'codepen',
    title: 'CodePen',
    profileURL: 'https://codepen.io/jmtov/',
  },
  instagram: {
    name: 'instagram',
    title: 'Instagram',
    profileURL: 'https://instagram.com/jmtov/',
  },
}
